<template>
  <div class="work">
    <b-container>
      <div class="text-center mb-5">
        <h2 class="font-weight-bold">Get in Touch with Us Now</h2>
        <p class="mt-3">
          To request a callback, kindly fill out the form provided.
        </p>
        <p>
          If you require urgent door repair service, have inquiries, or wish to
          speak with a customer care representative, please don't hesitate
          <br />
          to get in touch.
        </p>
      </div>
      <b-row>
        <b-col
          v-for="(item, index) in items"
          :key="index"
          cols="12"
          md="6"
          lg="4"
          class="mb-4"
        >
          <WorkCard :item="item" />
        </b-col>
      </b-row>

      <b-row class="justify-content-center">
        <b-col cols="12" md="4">
          <router-link to="/">
            <b-button class="mt-5 w-100 text-white">
              NextGen Garage Door Repairs
            </b-button>
          </router-link>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import office from "../assets/imgs/office.png";
import phone from "../assets/imgs/phone.png";
import email from "../assets/imgs/email.png";
import clock from "../assets/imgs/clock.png";
import WorkCard from "./WorkCard.vue";

export default {
  name: "WorkSection",
  components: { WorkCard },
  data() {
    return {
      items: [
        {
          step: "Call Us",
          description: "(551) 408-0587",
          subInfo: "Available 24/7 for emergencies",
          icon: phone,
          altText: "phone icon",
        },
        {
          step: "Business Address",
          description: "25 Rockwood , Englewood",
          subInfo: "Come visit our office",
          link: "(551) 408-0587",
          icon: office,
          altText: "office icon",
        },

        {
          step: "Service Area",
          description: "Bergen County",
          subInfo: "Serving 7 cities across NJ",
          icon: office,
          altText: "office icon",
        },
      ],
    };
  },
  mounted() {
    setTimeout(() => {
      this.step++;
    }, 2000);
  },
};
</script>

<style lang="scss" scoped>
.work {
  padding-top: 50px;
  padding-bottom: 70px;
  background-color: #f8fbff;

  &__title {
    font-size: 36px;
    font-weight: 700;
    text-align: center;
    line-height: 35px;
  }
  .btn {
    border-radius: 37px;
    // background-color: #1d1729;
    background-color: #0d47a1;
    padding: 10px;
    // font-size: 17px;
    font-size: 15px;
    letter-spacing: 2px;
    text-transform: uppercase;
    color: #ffffff;
    font-weight: 900;
    border: none !important;
  }

  .contact-cards-row {
    margin-bottom: 40px;
  }

  .btn {
    border-radius: 37px;
    background-color: #0d47a1;
    padding: 12px 24px;
    font-size: 15px;
    letter-spacing: 1px;
    text-transform: uppercase;
    color: #ffffff;
    font-weight: 700;
    border: none !important;
    transition: all 0.3s ease;

    &:hover {
      background-color: #0a1f5b;
      transform: translateY(-1px);
      box-shadow: 0 4px 12px rgba(13, 71, 161, 0.3);
    }
  }

  @media (max-width: 991.99px) {
    .contact-cards-row {
      .col-lg-3 {
        margin-bottom: 2rem;
      }
    }
  }

  @media (max-width: 767.99px) {
    padding-top: 70px;
    padding-bottom: 70px;

    &__title {
      font-size: 28px;
      margin-bottom: 40px;
    }
    h2 {
      font-size: 20px;
    }
  }
}
</style>
